if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        const openedBy = this.openedBy;
        super.hide();
        openedBy?.blur?.();
        document.body.dispatchEvent(
          new CustomEvent('productModalClosed', {
            detail: {
              modal: this,
              opener: openedBy,
            },
          })
        );
      }

      async show(opener) {
        await this.preloadActiveMedia(opener);
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaId(opener = this.openedBy) {
        return opener?.getAttribute('data-media-id');
      }

      getActiveMedia(opener = this.openedBy) {
        const mediaId = this.getMediaId(opener);
        if (!mediaId) return null;
        return this.querySelector(`[data-media-id="${mediaId}"]`);
      }

      preloadActiveMedia(opener) {
        const activeMedia = this.getActiveMedia(opener);
        const image = activeMedia?.matches('img') ? activeMedia : activeMedia?.querySelector('img');
        if (!image || image.complete) return Promise.resolve();

        image.loading = 'eager';
        image.fetchPriority = 'high';

        const imageReady = image.decode ? image.decode().catch(() => {}) : new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });

        return Promise.race([
          imageReady,
          new Promise((resolve) => setTimeout(resolve, 500)),
        ]);
      }

      showActiveMedia() {
        const activeMedia = this.getActiveMedia();
        if (!activeMedia) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.getMediaId()}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
